import { ParticleField } from '@/components/visuals/ParticleField'
import { ShotFrame } from '@/components/primitives'

const FLOW = ['Sources', 'Hopper', 'Queues', 'Teams', 'Outcomes'] as const

/**
 * The operating field, the site's one orchestrated visual moment.
 * Hairline grid + ambient particles + real Omni proof in a corner-bracketed
 * frame + flow rail.
 */
export function OperatingField() {
  return (
    <div className="relative">
      <div
        aria-hidden="true"
        className="field-grid pointer-events-none absolute -inset-10 opacity-70 [mask-image:radial-gradient(75%_75%_at_50%_45%,black,transparent)]"
      />
      <ParticleField />
      <div className="relative">
        <ShotFrame
          src="/images/omni-dash-1100w.webp"
          srcSet="/images/omni-dash-768w.webp 768w, /images/omni-dash-1100w.webp 1100w, /images/omni-dash-1600w.webp 1600w"
          sizes="(min-width: 1024px) 64vw, 100vw"
          width={1100}
          height={631}
          alt="TLDNXS Omni operating dashboard"
          tag="Real TLDNXS Omni · demo account"
          eager
        />
        <ol
          aria-label="Operating flow: sources, hopper, queues, teams, outcomes"
          className="mt-5 flex flex-wrap items-center gap-y-2"
        >
          {FLOW.map((stage, i) => (
            <li key={stage} className="flex items-center">
              <span className="font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-ink-mute">
                {stage}
              </span>
              {i < FLOW.length - 1 && (
                <span aria-hidden="true" className="mx-2.5 text-signal/70">
                  →
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </div>
  )
}
